import { withModifiers as _withModifiers, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-1b4ac0f4")

_pushScopeId("data-v-1b4ac0f4")
const _hoisted_1 = { class: "SwipeablePanel__head-container" }
const _hoisted_2 = {
  key: 0,
  class: "SwipeablePanel__head"
}
const _hoisted_3 = { class: "SwipeablePanel__body" }
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock("div", {
    class: ["SwipeablePanel", {
      'SwipeablePanel--dark': _ctx.dark,
    }],
    style: {
      bottom: `${_ctx.baseOffset}px`,
    },
    onClick: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["stop"]))
  }, [
    (_ctx.overlay)
      ? (_openBlock(), _createBlock("div", {
          key: 0,
          class: ["SwipeablePanel__overlay", {
        'SwipeablePanel__overlay--dark': _ctx.dark,
      }],
          onClick: _cache[1] || (_cache[1] = $event => (_ctx.$emit('backclick'))),
          onTouchMove: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["prevent"]))
        }, null, 34))
      : _createCommentVNode("", true),
    _createVNode("div", {
      class: ["SwipeablePanel__inner", { 'SwipeablePanel__inner--spacing': _ctx.isBottomSpace }],
      ref: "inner"
    }, [
      _createVNode("div", _hoisted_1, [
        (!_ctx.hideHead)
          ? (_openBlock(), _createBlock("div", _hoisted_2))
          : _createCommentVNode("", true)
      ]),
      _createVNode("div", _hoisted_3, [
        _renderSlot(_ctx.$slots, "default")
      ]),
      (_ctx.$slots.bottom)
        ? _renderSlot(_ctx.$slots, "bottom", { key: 0 })
        : _createCommentVNode("", true)
    ], 2)
  ], 6))
})